import { FC } from 'react'
import RightRobotCard from './common/RightRobotCard'
import useWindowSize from 'components/util/useWindowSize'

type Props = {}
const KeyBenefitsCard: FC<Props> = ({}) => {
  const size = useWindowSize()
  return (
    <RightRobotCard
      className='key-benefits-card'
      imageContainerWidth={size.isLgOrHigher ? '37%' : '100%'}
      image={{
        alt: 'Robot torso with office imagery',
        desktop: {
          dimensions: {
            height: 517,
            width: 487,
          },
          src: '/images/new/robot-torso-crop.png',
        },
        mobile: {
          dimensions: {
            height: 1122,
            width: 696,
          },
          src: '/images/new/robot-arm-mail.png',
        },
      }}
      reverseColumnOrder={!size.isLgOrHigher}
      imageStyle={{
        height: '100%',
        maxWidth: '100%',
        objectFit: 'cover',
        objectPosition: 'left',
      }}
    >
      <div
        className='d-flex flex-1 flex-column px-4 pe-lg-0 ps-lg-20 pt-lg-16 pb-8 fw-semibold mt-lg-0 mt-n16'
        style={{
          marginRight: size.isLgOrHigher ? '-8%' : undefined,
        }}
      >
        <h2 className='lh-105 fw-semibold mb-6 fs-fluid-40-80 d-block pe-5'>
          The Key Benefits of a{' '}
          <span className='text-gradient-purple'>Virtual Office Address</span>
        </h2>
        <div className='gap-4 d-flex flex-column'>
          <span className='fs-fluid-20-28 '>
            A virtual office plan at Hoxton Mix is ideal for small businesses,
            entrepreneurs, freelancers and startups looking for a prime virtual
            office address in London.
          </span>

          <span className='content lh-132 fs-fluid-18-22'>
            Get a desirable address without the need of renting a physical
            office and improve your image with potential clients. With our
            virtual office, you can specify our City address as your company's
            registered address.
          </span>
        </div>
      </div>
    </RightRobotCard>
  )
}

export default KeyBenefitsCard
